<template>
  <div>
    <a-modal
      width="660px"
      title="需求退回"
      :visible="visible"
      :ok-button-props="{ props: { loading: loading } }"
      @cancel="onClose"
      @ok="onOk"
    >
      <a-form-model ref="form" :form="formData" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }" :rules="rules" :model="formData">
        <a-form-model-item label="退回原因" prop="comment">
          <vditor-editor v-model="formData.comment" :height="200" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { workflowForceMove } from '@/api/business/requirement';
import VditorEditor from '@/components/VditorEditor';

export default {
  components: { VditorEditor },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        'project_id': 0,
        'workflow_id': 0,
        'comment': ''
      },
      rules: {
        comment: [{ required: true, message: '请填写退回原因', trigger: 'blur' }]
      }
    };
  },
  computed: {
  },
  methods: {
    onOpen() {
      this.visible = true;
    },

    onClose() {
      this.visible = false;
      this.formData = {
        'project_id': 0,
        'workflow_id': 0,
        'comment': ''
      };
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          const _data = JSON.parse(JSON.stringify(this.formData));
          _data.workflow_id = this.dataSource.flowId;
          workflowForceMove(_data).then(() => {
            this.$emit('saveOk');
            this.$message.success('退回成功');
            this.onClose();
            this.loading = false;
          })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}
</style>
